<template>
  <div class="editIntersetGroup">
    <!--控制范围信息-->
    <el-form
      ref="editIntersetGroup"
      label-position="right"
      label-width="110px"
      :rules="rules"
      :model="detail"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="部门组编码" prop="interestGroupCode">
            <el-input v-model="detail.interestGroupCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="部门组名称" prop="interestGroupName">
            <el-input v-model="detail.interestGroupName" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="计息公司" prop="interestCompanyCode">
            <el-select
              v-model="detail.interestCompanyCode"
              clearable
              filterable
              @change="changeCompany"
              disabled
            >
              <el-option
                v-for="(item, index) in companyList"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="计息公司编码">
            <el-input v-model="detail.interestCompanyCode" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="department-content">{{ this.$t('company.controlRangeTitle') }}</div>
    <!--新增/删除按钮-->
    <vxe-toolbar>
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="insertEvent()"
          >{{ $t('xTable.insert') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          @click="deleteEvent()"
          >{{ $t('xTable.delete') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-table
      border
      size="mini"
      show-overflow
      show-header-overflow
      ref="xTable"
      class="edit-table"
      :data="tableData"
      :edit-rules="validRules"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
    >
      <vxe-table-column type="checkbox" width="50"></vxe-table-column>
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        field="interestDepartmentCode"
        title="计息部门名称"
        :editRender="{
          name: 'ElSelect',
          props: { clearable: true, filterable: true },
          options: this.departmentList,
          events: { change: (obj) => this.updateCol(obj.row, 'interestDepartmentCode') },
        }"
      >
      </vxe-table-column>
      <vxe-table-column field="interestDepartmentCode" title="计息部门编码"> </vxe-table-column>
      <vxe-table-column
        field="inDate"
        title="调整部门组日期"
        :editRender="{
          name: 'ElDatePicker',
          props: { clearable: true, valueFormat: 'yyyy-MM-dd' },
        }"
      >
      </vxe-table-column>
      <vxe-table-column
        field="outDate"
        title="离开部门组日期"
        :editRender="{
          name: 'ElDatePicker',
          props: { clearable: true, valueFormat: 'yyyy-MM-dd' },
        }"
      >
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/masterData/intersetGroup.js';
  import XEUtils from 'xe-utils';
  // import SiruiTable from '@/components/SiruiTable';
  // import { isEqual } from '@/common/js/util';

  export default {
    name: 'editIntersetGroup',
    components: {
      // SiruiTable,
    },
    data() {
      return {
        options: [],
        detail: {},
        tableData: [],
      };
    },
    props: ['departmentList', 'companyList'],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      columnList() {
        return [
          {
            prop: 'companyDepartmentName',
            label: this.$t('company.table.departmentName'),
          },
        ];
      },
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value != null && value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        return {
          interestGroupName: [
            {
              required: true,
              message: '请输入部门组名称',
              trigger: 'blur',
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
          interestCompanyCode: [
            {
              required: true,
              message: '请选择计息公司',
              trigger: 'blur',
            },
          ],
        };
      },
      validRules() {
        return {
          interestDepartmentCode: [{ required: true, message: '请选择计息部门' }],
          inDate: [{ required: true, message: '请选择调整部门组日期' }],
        };
      },
    },
    methods: {
      initData(detail) {
        if (this.$refs['editIntersetGroup']) {
          this.$refs['editIntersetGroup'].resetFields();
        }
        this.detail = XEUtils.clone(detail, true);
        let params = { interestGroupCode: detail.interestGroupCode };
        this.changeCompany(this.detail.interestCompanyCode);
        //所属部门组
        this.$axios.post(API.INTERSET_INOUT_LIST, params).then((res) => {
          if (0 == res.data.code) {
            this.tableData = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 变更公司
      changeCompany(val) {
        this.detail.interestCompanyName = val
          ? this.companyList.find((it) => it.value == val)?.label
          : '';
        this.tableData = [];
        // 获取部门信息
        this.$emit('getdepartmentList', this.detail.interestCompanyCode);
      },
      // 表格变化
      updateCol(row, prop) {
        console.log(row);
        if (prop == 'interestDepartmentCode') {
          row.interestDepartmentName = row[prop]
            ? this.departmentList.find((it) => it.value == row[prop])?.label
            : '';
        }
      },
      //新增一行
      insertEvent() {
        // const tableList = this.$refs.xTable.getTableData().fullData;
        this.$refs.xTable.validate((valid) => {
          if (valid) {
            const record = {
              interestDepartmentCode: null,
              interestDepartmentName: null,
              inDate: null,
              outDate: null,
              interestGroupCode: null,
              interestGroupName: null,
            };
            this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
          }
        });
      },
      //删除一行
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          this.$refs.xTable.removeSelecteds();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      // 校验付款申请表单
      validateForm() {
        return new Promise((resolve, reject) => {
          this.$refs['editIntersetGroup'].validate((valid) => {
            if (valid) {
              resolve(true);
            } else {
              reject();
              return false;
            }
          });
        });
      },

      // 获取表格数据并校验

      // 返回数据
      exportChildData() {
        const tableData = this.$refs.xTable.getTableData().fullData;
        console.log(tableData);
        // 点击提交，走校验
        if (tableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.xTable.validate().then(() => {
              resolve(tableData);
            });
          });
        }
      },
      //保存
      async addSure() {
        let flag = await this.validateForm(); //校验表单
        if (!flag) return;

        let detailList = await this.exportChildData();

        this.$emit('setLoading', { loading: true });
        let params = XEUtils.clone(this.detail, true);
        params.detailList = detailList;
        this.$axios.post(API.INTERSET_GROUP_SAVE, params).then((res) => {
          this.$emit('setLoading', { loading: false, edit: false });
          if (0 != res.data.code) {
            this.$alert(res.data.msg);
          } else {
            this.$emit('getData');
            this.$message({
              showClose: true,
              message: res.data.msg || this.$t('message.success'),
              type: 'success',
            });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
</style>
